import { MoonIcon, SunIcon } from '@/components/icons'
import { useTheme } from 'next-themes'
import { Button } from '@/components/ui/button'

/** Compact light/dark toggle for ops chrome. */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const dark = resolvedTheme === 'dark'
  return (
    <Button
      type="button"
      variant="outline"
      size="icon-sm"
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
    >
      {dark ? (
        <SunIcon className="size-4" aria-hidden />
      ) : (
        <MoonIcon className="size-4" aria-hidden />
      )}
    </Button>
  )
}
